module.exports = {
    "Empty": `Tu\u{161}\u{10D}ias`
};


//# sourceMappingURL=lt-LT.main.js.map
